import moment from "moment";
import React, { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { EditableFeed } from "./EditableFeed";

const EditableFeedWrapper = ({
  reviews,
  ReviewActions,
  authUser,
  getEntity,
  idField,
}) => {
  //selected feed state for editing

  const [selectedFeed, setSelectedFeed] = useState(null);

  return (
    <>
      {[...reviews]
        .sort((a, b) => {
          return moment(a.created_at).isAfter(moment(b.created_at)) ? -1 : 1;
        })
        .map((review) => (
          <EditableFeed
            key={review.id}
            entity={review}
            isAuthor={Number(review.user_id) === Number(authUser.id)} //use conversion to avoid bugs in production
            ReviewActions={ReviewActions}
            authUser={authUser}
            getEntity={getEntity}
            idField={idField}
            selectedFeed={selectedFeed}
            setSelectedFeed={setSelectedFeed}
            feedId={review.id}
          />
        ))}
    </>
  );
};

export default EditableFeedWrapper;
